export default __webpack_public_path__ + "static/media/calendaricon.6f1f9cf6.svg";